import React from "react";
import "./SearchJoyItem.less";
import { ListItemData, ListItemProps } from "@jd/focus-desktop-comps/lib/es/ListItem";
import { useTranslation } from "react-i18next";
import { changeEgovUrl } from "@/utils/tools";
import { time } from "@/components/Joyspace/util";
import IconFont from "@/components/icon";
import { Tooltip, message } from "antd";
import events from "@/components/Joyspace/context/events";
import { folderTypeEnum } from "@/components/Joyspace/config/permissions.config";
import { useHistory } from "react-router-dom";
import bus from "@/utils/bus";
import { getGroupInfo } from "@/api/egroup";
import logger from "@/utils/logger";
import { FocusSDK } from "@/utils";

const SearchJoyItem = (
  props: { data: ListItemData; onClick?: (data: ListItemData) => void; t: any } & ListItemProps
) => {
  const { data, onClick, ...rest } = props;
  const [t] = useTranslation("calendar");
  const history = useHistory();
  const handleParentFolder = async (dataParam: ListItemData) => {
    const { origin: d } = dataParam;
    const { spaceType, parentId: gid, spaceId: groupId } = d;
    bus.emit("onHideGlobalSearch", false);
    switch (spaceType) {
      case folderTypeEnum.MY:
        history.push(gid === "root" ? "/joyspace/myspace" : `/joyspace/myspace?categoryId=${gid}`);
        break;
      case folderTypeEnum.SHARE:
        history.push(
          gid === "root" ? "/joyspace/teamspace" : `/joyspace/teamspace?categoryId=${gid}`
        );
        break;
      case folderTypeEnum.GROUP:
        try {
          const res = await getGroupInfo({
            groupIds: [{ groupId: groupId }]
          });
          // eslint-disable-next-line max-depth
          if (res.groups[0].status === 0) {
            message.error("该群已解散！");
          } else {
            setTimeout(() => {
              history.push(`/messages/g/${groupId}?top=true`);
              events.emit("joyspace.groupSpace", {
                visible: true,
                gname: d?.spaceName,
                gid: groupId,
                categoryId: gid
              });
            }, 400);
          }
        } catch (error) {
          message.error("当前版本暂不支持，请升级至最新版本");
          FocusSDK.printLog("handleSearchType groupSpace ==>", d, error.message?.toString());
        }

        break;
      default: {
        message.error("当前版本暂不支持，请升级至最新版本");
        return;
      }
    }
  };
  return (
    <div
      className="search-joy-item"
      onClick={() => {
        if (onClick) {
          onClick(data);
        }
      }}
    >
      <div className="search-joy-item-icon">
        <img src={changeEgovUrl(data.avatar as string) || ""} alt="" />
      </div>
      <div className="search-joy-item-content">
        <div className="search-joy-item_title color-primary">{data.name}</div>
        <div className="search-joy-item_text">{data.con}</div>
        <div className="search-joy-item-user">
          {data.origin?.author && (
            <span className="search-joy-item_info">所有者：{data.origin?.author.name}</span>
          )}
          {data.origin?.spaceType === 13 && (
            <Tooltip title={"知识库：" + data.origin?.spaceName} destroyTooltipOnHide={true}>
              <span
                className="search-joy-item_folder"
                onClick={(e: any) => {
                  e.persist();
                  e.stopPropagation();
                  return;
                }}
              >
                <IconFont type="iconzhishiku" />
                {" 知识库：" + data.origin?.spaceName}
              </span>
            </Tooltip>
          )}
          {data.origin?.spaceType !== 13 && data.origin?.parentName && (
            <Tooltip
              title={
                data.origin?.fullPathNames ? data.origin?.fullPathNames.replace(/\$@\$/g, "/") : "/"
              }
              destroyTooltipOnHide={true}
              overlayStyle={{
                display:
                  data.origin?.parentId === "groupRoot" || data.origin?.parentId === "/"
                    ? "none"
                    : "block"
              }}
            >
              <span
                className={`search-joy-item_folder ${
                  data.origin?.parentId === "groupRoot" || data.origin?.parentId === "/"
                    ? ""
                    : "folder-hover"
                }`}
                onClick={(e: any) => {
                  e.persist();
                  e.stopPropagation();
                  if (data.origin?.parentId === "groupRoot" || data.origin?.parentId === "/") {
                    return;
                  }
                  handleParentFolder(data);
                }}
              >
                <IconFont type="icona-ic_app_im_storage3x" />
                {" " + data.origin?.parentName}
              </span>
            </Tooltip>
          )}
          {data.origin?.modifiedAt && (
            <span className="search-joy-item_time">
              {time.format(data.origin?.modifiedAt) + " 更新"}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchJoyItem;
